module.exports = __webpack_public_path__ + "static/media/firebase.b5bcb237.svg";